import { Component } from "react";
import Container from "react-bootstrap/Container";
import UpgradePlan from "member/components/UpgradePlan";
import { connect } from "react-redux";
import TableResult from "./TableResult";
import PropTypes from "prop-types";

import {
  isProfilePlan,
  isIndividualPlan,
  isInstitutionalPlan,
} from "shared/plans";

class Worksheet extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { search_results, currentUser, getMembers, params } = this.props;
    const institutionalUser =
      isInstitutionalPlan(currentUser) ||
      isIndividualPlan(currentUser) ||
      isProfilePlan(currentUser);

    return (
      <div style={{ backgroundColor: "white", padding: "16px" }}>
        {!institutionalUser && <UpgradePlan />}
        {institutionalUser && search_results.length > 0 ? (
          <TableResult getMembers={getMembers} params={params} />
        ) : (
          institutionalUser && "No results"
        )}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const { searchResults, users } = state;

  const {
    result: { search_results },
  } = searchResults;

  return {
    search_results,
    currentUser: users.user,
  };
}

Worksheet.propTypes = {
  getMembers: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, null)(Worksheet);
